import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Input, Button, Row, Col } from 'antd';
import PropTypes from 'prop-types';
import { UserAddOutlined } from '@ant-design/icons';
import { fetchServer } from '../Base/modelManager';
import { Link } from 'react-router-dom';
import { serverError } from '../../redux/actions/serverManagerAction';





class PasswordLost extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            processed: false,
            capswarning: false,
            error: null
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit(values) {
        //e.preventDefault();
        const request = {
            endPoint: this.props.authUrl + '/recoverPasswordClient',
            method: 'POST',
            params: values
        }

        fetchServer(request, (json) => {
            this.setState({
                processed: true,
                error: null
            })
        },
            error => this.setState({ error: error.error })
        )


    }


    onBlur = () => {
        this.setState({ capswarning: false });

    }


    onKeyDown = keyEvent => {
        if (keyEvent.getModifierState("CapsLock")) {
            this.setState({ capswarning: true });
        } else {
            this.setState({ capswarning: false });
        }
    };

    render() {
        //const { errors } = this.state;
        //const { getFieldDecorator } = this.props.form;
        if (this.state.processed === false)
            return (

                <div className='container' style={{ margin: '0 auto', width: '400px', height: '320px' }}>
                    <h2 style={{ marginBottom: '40px' }}>Entrez votre adresse email</h2>
                    <Form onFinish={this.handleSubmit} className='PasswordLost-form'>
                        <Form.Item name='email' rules={[{ required: true, message: 'Entrez votre Identifiant!' }]}>
                            <Input
                                prefix={<UserAddOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                                placeholder='Username'
                                onChange={this.handleInputChange}
                                name='email'
                            />
                        </Form.Item>
                        { this.state.error!==null ?
                           <p style={{ color: 'rgba(255, 0, 0, 0.88)' }} >{this.state.error.message	}</p>
                        :null

                        }

                        <Form.Item>
                            <Row>
                                <Col span={6}>
                                    <Button type='primary' htmlType='submit' className='PasswordLost-form-button'>
                                        Reinitialiser Mon mot de passe
                                    </Button>
                                </Col>
                            </Row>
                        </Form.Item>
                    </Form>
                </div>

            )
        else return (
            <div className='container' style={{ margin: '0 auto', width: '400px', height: '320px' }}>
                <p>Un email contenant le lien de reinitialisation du mot de passe a été envoyé à l'adresse {this.state.email}</p>
                <Link to='/Login'>Retourner à l'écran de connection</Link>
            </div>
        )
    }
}



const mapStateToProps = state => {
    return {
        error: state.authentication.error,
        authorized: state.authentication.authorized,
        authUrl: state.server.authUrl,
    }
}
PasswordLost.propTypes = {
    error: PropTypes.any,
    dispatch: PropTypes.func,
    form: PropTypes.any,
    authorized: PropTypes.bool,
    authUrl: PropTypes.string,

};

export default connect(mapStateToProps)(PasswordLost)